import { render, staticRenderFns } from "./process-table.vue?vue&type=template&id=ed4e92ee&scoped=true"
import script from "./process-table.vue?vue&type=script&lang=js"
export * from "./process-table.vue?vue&type=script&lang=js"
import style0 from "./process-table.vue?vue&type=style&index=0&id=ed4e92ee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed4e92ee",
  null
  
)

export default component.exports